import { useCallback } from 'react';
import { statsService } from '../services/statsService';
import { type LeaderboardUser, StatsLeaderboard } from './StatsLeaderboard';

export const TriggerLogsLeaderboard = () => {
    const fetchUsers = useCallback(async (): Promise<LeaderboardUser[]> => {
        const users = await statsService.getTopUsersByTriggerLogCount(20);
        return users.map((u) => ({
            userId: u.userId,
            email: u.email,
            displayName: u.displayName,
            value: u.triggerLogCount,
            memberSince: u.memberSince,
        }));
    }, []);

    return (
        <StatsLeaderboard
            title="Trigger Logs Leaderboard"
            valueLabel="Trigger Logs"
            valueUnit="logs"
            emptyMessage="No users with trigger logs found."
            fetchUsers={fetchUsers}
        />
    );
};
